// src/pages/ResetPassword.jsx
import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../api';
import './AuthForm.css';
import Footer from '../components/Footer';

const ResetPassword = () => {
  const { token } = useParams();
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const [isValidToken, setIsValidToken] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  // Valider le token à l'ouverture
  useEffect(() => {
    const validateToken = async () => {
      console.log('🔄 ResetPassword componentDidMount, token:', token);
      
      if (!token) {
        console.error('❌ No token found in URL');
        setError('Token manquant dans l\'URL');
        setLoading(false);
        return;
      }

      try {
        console.log('📡 Calling GET /api/auth/reset-password/' + token);
        const res = await api.get(`/api/auth/reset-password/${token}`);
        console.log('✅ Token validation success:', res.data);
        setIsValidToken(true);
        setError('');
        setLoading(false);
      } catch (err) {
        console.error('❌ Token validation failed:', err);
        console.error('Error response:', err.response?.data);
        console.error('Error status:', err.response?.status);
        const errorMsg = err.response?.data?.msg || err.message || 'Lien de réinitialisation invalide ou expiré';
        setError(errorMsg);
        setIsValidToken(false);
        setLoading(false);
      }
    };

    validateToken();
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!password.trim()) {
      setMessage('Veuillez entrer un mot de passe');
      return;
    }
    try {
      console.log('📡 Calling POST /api/auth/reset-password/' + token);
      const res = await api.post(`/api/auth/reset-password/${token}`, { password });
      console.log('✅ Password reset success:', res.data);
      setMessage(res.data.msg || 'Mot de passe réinitialisé avec succès !');
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      console.error('❌ Password reset failed:', err);
      const errorMsg = err.response?.data?.msg || err.message || 'Erreur lors de la réinitialisation';
      setMessage(errorMsg);
    }
  };

  console.log('🎨 Rendering ResetPassword - loading:', loading, 'isValidToken:', isValidToken, 'error:', error);

  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: 'var(--app-background)' }}>
      <header className="p-4 text-center border-b bg-white">
        <button onClick={() => navigate(-1)} className="link-fuchsia text-sm">
          ← Retour
        </button>
      </header>

      <main className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-md bg-white rounded-2xl shadow-lg p-8">
          
          {loading && (
            <div className="text-center">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">Réinitialiser le mot de passe</h2>
              <p className="text-gray-600">⏳ Vérification du lien...</p>
            </div>
          )}

          {!loading && error && (
            <div className="text-center">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">❌ Erreur</h2>
              <p className="text-red-500 font-semibold mb-6 break-words">{error}</p>
              <button
                onClick={() => navigate('/login')}
                className="btn-primary px-6 py-2 w-full"
              >
                Retour à la connexion
              </button>
            </div>
          )}

          {!loading && isValidToken && (
            <form onSubmit={handleSubmit} className="space-y-4">
              <h2 className="text-2xl font-bold text-gray-800 text-center mb-6">Réinitialiser le mot de passe</h2>
              
              <input
                type="password"
                placeholder="Nouveau mot de passe"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[var(--accent-primary)]"
              />
              
              <button type="submit" className="btn-primary w-full py-3 font-semibold">
                Réinitialiser
              </button>

              {message && (
                <p className={`text-center text-sm font-medium ${message.includes('Erreur') ? 'text-red-500' : 'text-green-500'}`}>
                  {message}
                </p>
              )}
            </form>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ResetPassword;
